import React, { useState, useEffect } from "react";
import { Select } from 'antd';
import { fetchAllNodes } from '../../api/inspiration';

const { Option } = Select;

export default React.memo(props => {
    const { setNode, nodeTagType, node } = props;
    const [options, setOptions] = useState([]);

    useEffect(() => {
        getAllNodes('');
    }, []);

    const getAllNodes = async searchWord => {
        const res = await fetchAllNodes(searchWord, nodeTagType ?? '');
        if (res?.error?.code == 0 && res.data?.length > 0) {
            setOptions(res.data);
        } else {
            setOptions([]);
        }
    };

    const handleSearch = v => {
        setNode(null);
        if (v.trim()) {
            getAllNodes(v);
        } else {
            getAllNodes('');
        }
    };

    const handleChange = v => {
        for (let item of options) {
            if (v == item.id) {
                setNode(item);
                return;
            }
        }

        setNode(null);
        
    };

    return (
        <Select
            showSearch
            placeholder='请输入节点名称'
            defaultActiveFirstOption={false}
            filterOption={false}
            onSearch={handleSearch}
            onChange={handleChange}
            notFoundContent={null}
            value={node?.id}
        >
            {
                options.map(v => {
                   return (
                       <Option key={v.id} value={v.id}>{v.word}</Option>
                   )
                })
            }
        </Select>
    )
});